import React, { useEffect, useState } from 'react';
import Breadcrumb from '../../../components/BreadCrumb/breadCrumb';
import Strings from '../../../constants/stringConstant';
import Path from '../../../constants/path';
import sharedStyles from '../Masters.module.css';
import { Box, Grid, IconButton } from '@mui/material';
import SearchBox from '../../../components/SearchBox/searchBox';
import ButtonComp from '../../../components/Button/buttonComp';
import { ReactComponent as AddIcon } from '../../../assets/images/addIconWhite.svg';
import PaginationComp from '../../../components/Pagination/paginationComp';
import ModalwithButton from '../../../components/Modal/modalwithButton';
import AddEditDropdownMaster from './AddEditDropdownMaster';
import { toast } from 'react-toastify';
import makeApiCall from '../../../api/makeApiCall';
import SuccessModal from '../../../components/Modal/successModal';
import { ReactComponent as EditSharpIcon } from '../../../assets/images/editIcon.svg';
import TableComp from '../../LoanApplicationsPage/LoanApplicationsDashboard/OtherLoanApplicationStages/componenets/StaticPages/EligibilityCheck/CamTab/TableComp';
import { useSelector } from 'react-redux';
import { addUpdateDropdownMaster, fetchDropdownMaster } from '../../../api/request/masterFetchApi/masterFetchApi';

function DropdownMaster() {
    const paths = [
        {
            name: Strings.masters.masters,
            link: Path.dropdown_master,
        },
        { name: Strings.masters.dropdown_master, link: '' },
    ];
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [addEditDropdownModal, setAddEditDropdownModal] = useState(false);
    const [type, setType] = useState('add');
    const [selectedRowObject, setSelectedRowObject] = useState({});
    const [allRows, setAllRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [successModal, setSuccessModal] = useState(false);
    const [failedModal, setFailedModal] = useState(false);
    const [isModalVisible, setModalVisible] = useState(false);
    const { roleBased } = useSelector(state => state.rbacValue);
    const isEditDropdown = roleBased?.masters?.sections?.dropdown_master !== 'edit';
    console.log(isEditDropdown);
    const rowPerTable = 10;

    const totalPages = Math.ceil(allRows.length / rowPerTable);
    const noRecordsFound = !loading && allRows.length === 0;
    const rows = allRows
        .slice((currentPage - 1) * rowPerTable, currentPage * rowPerTable)
        .map(row => ({ ...row, subCategoryDisplay: row?.subCategory || '-' }));

    function toggleAddEditDropdownModal() {
        setAddEditDropdownModal(!addEditDropdownModal);
    }

    useEffect(() => {
        fetchDropdownMasterApi();
    }, [searchQuery, currentPage]);

    useEffect(() => {
        if (successModal) {
            setTimeout(() => {
                handleSuccessModal();
            }, 2000);
        }
    }, [successModal]);

    useEffect(() => {
        if (failedModal) {
            setTimeout(() => {
                handleFailedModal();
            }, 2000);
        }
    }, [failedModal]);

    const handleApiError = response => {
        toast.error(response?.data?.error?.errorMessage, { position: 'top-right' });
    };

    const fetchDropdownMasterApi = async () => {
        setLoading(true);
        try {
            const requestPayload = {
                searchTerm: searchQuery,
                pageNumber: currentPage - 1,
                pageSize: rowPerTable,
            };
            const response = await makeApiCall(fetchDropdownMaster(requestPayload));
            if (response?.data?.status === Strings?.success) {
                const data = response?.data?.data;
                setAllRows(Array.isArray(data) ? data : data?.content ?? []);
            } else {
                setAllRows([]);
                handleApiError(response);
            }
        } catch (error) {
            toast.error(Strings.apiError, { position: 'top-right' });
        } finally {
            setLoading(false);
        }
    };

    const buildPayload = data => ({
        id: data?.id || 0,
        ddValue: data?.ddValue?.trim() ?? '',
        category: data?.category?.trim() ?? '',
        subCategory: data?.subCategory?.trim() || null,
        status: data?.status ?? true,
    });

    const addUpdateDropdownMasterApi = async data => {
        setLoading(true);
        try {
            const response = await makeApiCall(addUpdateDropdownMaster(buildPayload(data)));
            if (response?.data?.status === Strings?.success) {
                setSuccessModal(true);
                fetchDropdownMasterApi();
            } else {
                handleApiError(response);
                setFailedModal(true);
                setSuccessModal(false);
            }
        } catch (error) {
            toast.error(Strings.apiError, { position: 'top-right' });
        } finally {
            setLoading(false);
        }
    };

    const loanColumns = [
        { label: 'Dropdown Value', field: 'ddValue' },
        { label: 'Category', field: 'category' },
        { label: 'Sub Category', field: 'subCategoryDisplay' },
    ];

    const handleSearch = query => {
        setSearchQuery(query);
        setCurrentPage(1);
    };

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const handleSuccessModal = () => {
        setSuccessModal(false);
    };

    const handleFailedModal = () => {
        setFailedModal(false);
    };

    const handleStatusChange = selectedRow => {
        setSelectedRowObject(selectedRow);
        setModalVisible(true);
    };

    const handleStatusCancel = () => {
        setModalVisible(false);
        setSelectedRowObject({});
    };

    const handleConfirm = async () => {
        setLoading(true);
        try {
            const requestPayload = buildPayload({
                ...selectedRowObject,
                status: !selectedRowObject.status,
            });
            const response = await makeApiCall(addUpdateDropdownMaster(requestPayload));
            if (response?.data?.status === Strings.success) {
                fetchDropdownMasterApi();
                setModalVisible(false);
                setSelectedRowObject({});
            } else {
                handleApiError(response);
            }
        } catch (error) {
            console.error('API Error:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box className={sharedStyles.main_container}>
            <Breadcrumb paths={paths} />
            <Box className={sharedStyles.secondary_container}>
                <Grid
                    container
                    sx={{
                        gap: '12px',
                        justifyContent: 'space-between',
                    }}>
                    <Grid item>
                        <SearchBox searchQuery={searchQuery} onSearch={handleSearch} />
                    </Grid>
                    <Grid item>
                        <Grid
                            container
                            sx={{
                                gap: '12px',
                            }}>
                            <ButtonComp
                                type="submit"
                                className="text-bold-16px"
                                endIcon={<AddIcon />}
                                value={Strings.masters.add_new}
                                gradient="linear-gradient(168deg, #F37021 -13.5%, #FDBA12 119.9%)"
                                height="40px"
                                padding="14px 24px"
                                textcolor="#fff"
                                borderRadius="8px"
                                onClick={() => {
                                    setType('add');
                                    toggleAddEditDropdownModal();
                                }}
                                disabled={false}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <TableComp
                    loader={loading}
                    columns={loanColumns}
                    rows={rows}
                    editDisabled={false}
                    handleActionClick={row => {
                        setType('edit');
                        setSelectedRowObject(row);
                        toggleAddEditDropdownModal();
                    }}
                    showTotal={false}
                    firstColumnBgColor={'white'}
                    statusColumn={true}
                    statusChange={handleStatusChange}
                    noRecordsFound={noRecordsFound}
                    actionIcon={
                        <IconButton aria-label="close" disabled={false}>
                            <EditSharpIcon />
                        </IconButton>
                    }
                />
                {totalPages > 0 && !noRecordsFound && (
                    <PaginationComp
                        totalPages={totalPages}
                        currentPage={currentPage}
                        handlePageChange={handlePageChange}
                    />
                )}
            </Box>
            {addEditDropdownModal && (
                <ModalwithButton
                    open={addEditDropdownModal}
                    message={type === 'add' ? 'Add Dropdown Details' : 'Edit Dropdown Details'}
                    subMessage={
                        'Fill in the below details to add them to the master table'
                    }
                    leftRenderWithoutPadding
                    bolderHeadings
                    subMessageColor={'#475467'}
                    onClose={toggleAddEditDropdownModal}
                    minWidth={'50%'}>
                    <AddEditDropdownMaster
                        closeModal={toggleAddEditDropdownModal}
                        selectedRowObject={selectedRowObject}
                        type={type}
                        addUpdateDropdownMasterApi={addUpdateDropdownMasterApi}
                    />
                </ModalwithButton>
            )}
            <SuccessModal
                open={successModal}
                onClose={handleSuccessModal}
                message={
                    type === 'add'
                        ? Strings.masters.added_record
                        : Strings.masters.updated_record
                }
                subMessage={
                    type === 'add'
                        ? Strings.masters.added_record_des
                        : Strings.masters.updated_record_des
                }
            />
            <SuccessModal
                open={failedModal}
                onClose={handleFailedModal}
                message={
                    type === 'add'
                        ? Strings.masters.failed_added_record
                        : Strings.masters.failed_updated_record
                }
                subMessage={
                    type === 'add'
                        ? Strings.masters.failed_added_record_des
                        : Strings.masters.failed_updated_record_des
                }
                reject
            />
            <ModalwithButton
                open={isModalVisible}
                message={Strings.masters.status_change}
                subMessage={Strings.masters.status_change_msg}
                value={'Yes'}
                onClickButton={handleConfirm}
                onClose={handleStatusCancel}
                cancelBtn
            />
        </Box>
    );
}

export default DropdownMaster;
